export default {
    "en": {
        "admin": {
            "new_emp": "New employee",
            "new_hr": "New HR",
            "new_mentor": "New mentor",
            "new_manager": "New manager",
            "new_functional_manager": "New functional manager",
            "import": "Import",
            "manual": "Manually",
            "batch": "Package",
            "export": "Export",
            "log_history": "Log history",
            "tab_number": "Employee ID",
            "employee": "Employee",
            "employees": "Employees",
            "company": "Company",
            "business_item": "Business unit",
            "companies": "Companies",
            "no_companies_users": "Users not found",
            "department": "Department",
            "position": "Position",
            "fired_at": "Fired At",
            "phone": "Phone",
            "in_system": "On probation period",
            "in_white_list": "On white list",
            "source": "Source",
            "employee_data": "Employee data",
            "pernumber": "Employee ID",
            "novice": "Yes",
            "not_novice": "No",
            "roles": "Roles",
            "email": "Email",
            "subdivision": "Level 1 department",
            "subdivision2": "Level 2 department",
            "subdivision3": "Level 3 department",
            "subdivision4": "Level 4 department",
            "subdivision5": "Level 5 department",
            "no_division": "Not specified",
            "shift_at": "Shift end at",
            "mentor_can_edit": "Mentor's expanded rights",
            "without_probation": "No probation period",
            "user_not_found": "Employee is not found.",
            "employee_imported": "Employees are imported successfully.",
            "notify_button": "Notifications",
            "config_notification_title": "Employee selection",
            "save_settings": "Save",
            "notification_settings_updated": "Notification settings updated",
            "notification_settings_failed_updated": "BE alert settings not updated.",
            "add_subgroup": "Add subgroup",
            "new_group": "New group",
            "add_competence": "Add competence",
            "add_skill": "Add skill",
            "add_provider": "Add vendor",
            "rename_provider": "Rename vendor",
            "delete_provider_question": "Do you want to delete a vendor?",
            "provider": "Provider",
            "russian": "Russian",
            "english": "English",
            "french": "French",
            "providers": "Providers",
            "provider_add_error": "An error occured while creating a provider",
            "provider_edit_error": "An error occured while changing a provider",
            "provider_add_success": "Provider added successfully",
            "provider_edit_success": "Provider changed successfully",
            "provider_delete_success": "Provider has been successfully deleted",
            "can_edit_catalog": "Can work with catalog",
            "report_button": "Report",
            "competences": "Competences",
            "rename": "Rename",
            "delete": "Delete",
            "hide": "Make inactive",
            "show": "Make active",
            "matrix": "Matrix",
            "report_idp": "IDP report",
            "report_mandatory_learning": "Compulsory Education Report",
            "id": "ID",
            "be": "BE",
            "not_delete": "You can only delete an account that is whitelisted",
            "not_delete_manager": "You can only remove a link that you have created manually",
            "create_employee": "New employee",
            "connections": "Connections",
            "office": "Office / branch",
            "fio": "FIO",
            "fio_hr": "FIO of the new HR",
            "delete_manager_link_question": "Do you want to remove the managers link?",
            "delete_fmanager_link_question": "Do you want to remove the functional managers link?",
            "fmanager": "Func. manager",
            "employee_type": "Employee type",
            "hide_inactive": "Hide inactive",
            "add_matrix_activity": "Add activity to matrix",
            "import_matrix": "Matrix import",
            "make_active": "Make active",
            "make_not_active": "Make not active",
            "main_qualification": "Qualification (main)",
            "optional_qualification": "Qualification (optional)",
            "pbiot": "PBiOT",
            "first_aid": "First aid",
            "ecology": "Ecology",
            "gnvp": "GNVP",
            "professional": "Professional",
            "one_time": "1 time",
            "one_time_in_year": "1 time in year",
            "one_time_in_two_years": "1 time in 2 years",
            "one_time_in_three_years": "1 time in 3 years",
            "one_time_in_five_years": "1 time in 5 years",
            "one_time_in_ten_years": "1 time in 10 years",
            "active": "Active",
            "not_active": "Not active",
            "mandatory": "Mandatory",
            "additional": "Additional",
            "certificate": "Certificate",
            "qualification_certificate": "Qualification certificate",
            "protocol": "Protocol",
            "protocol_identity": "Protocol / identity",
            "create_matrix": "Add required activity",
            "edit_matrix": "Edit required activity",
            "direction": "Direction",
            "priority": "Priority",
            "documents": "Documents",
            "periodicity": "Periodicity",
            "activity_link": "Link to activity in the \"Catalogue\"",
            "matrix_import_error": "The learning matrix cannot be imported \nbecause one or more of the fields \ndoes not match the specified format. \nCheck the file and upload the correct version again."
        },
        "auth": {
            "login": "Log in",
            "logout": "Log out",
            "pernumber": "Employee ID",
            "password": "Password",
            "register": "Register",
            "failed": "Authorization failed.",
            "throttle": "Many authorization attempts. Try again in {seconds}, sec.",
            "token_not_found": "User token is not found."
        },
        "role": {
            "admin": "Administrator",
            "manager": "Manager",
            "managers": "Managers",
            "fmanager": "Functional manager",
            "fmanagers": "Functional managers",
            "employee": "Employee",
            "employees": "Employees",
            "mentor": "Mentor",
            "hr": "HR",
            "newbie": "New employee"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "plan_greater_probation": "Plan date greater user probation end date.",
            "you_have_no_assigned_tasks": "You have tasks without assigned date.",
            "path_to_file_corrupt": "Path to file corrupt.",
            "task_without_plan_date": "You have tasks without plan date.",
            "you_have_no_tasks": "Create at least 1 task.",
            "report_settings_required": "Required all fields.",
            "report_company_not_exist": "Company not exist.",
            "report_bad_date_format": "Invalid date format.",
            "can_not_be_competence": "Can not be competence.",
            "can_not_hide_not_competence": "Can not hide not competence.",
            "can_not_remove_not_empty_group": "Can not remove not empty group.",
            "can_not_remove_assigned_competence": "Can not remove assigned competence.",
            "can_not_add_skill_to_competence": "Can not add skill to competence.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": [],
            "import": {
                "pernumber_empty": "Employee ID is not specified",
                "pernumber_only_digits": "Employee ID can contain only numbers",
                "pernumber_not_unique": "Employee ID is not unique",
                "surname_not_exists": "Last name of employee is not filled in",
                "firstname_not_exists": "First name of employee is not filled in",
                "invalid_phone": "Invalid phone number format. 11 to 16 numbers are allowed.",
                "not_unique_phone": "Non-unique telephone number",
                "invalid_email": "Invalid format for email",
                "not_unique_email": "Non-unique email",
                "empty_company": "Employee's company is not filled in",
                "not_exist_company": "The system does not have such company",
                "empty_department": "Employee's section is not filled in",
                "not_exist_department": "The system does not have such employee section",
                "empty_position": "Employee's position is not filled in",
                "not_exist_position": "The system does not have  such position",
                "hired_empty": "Start date is not filled in",
                "invalid_date_format_hired": "Wrong start date format. The allowed format is 01/01/2020",
                "invalid_date_format_shift": "Wrong rotation end date format. The allowed format is 01/01/2020",
                "invalid_date_format_period": "Wrong probation end data format. The allowed format is 01/01/2020",
                "save_user_error": "Error in saving the user",
                "not_exist_subdivision": "There is no such department in the system"
            }
        },
        "modal": {
            "when_placeholder": "Select dates",
            "provider_placeholder": "Choose a provider",
            "place_placeholder": "Specify the venue",
            "duration_placeholder": "Enter duration in hours",
            "link_placeholder": "Insert link",
            "comment_placeholder": "Enter a comment",
            "description_placeholder": "Enter a description",
            "attached_by_you": "Attached by you",
            "attached_by_hr": "Attached by HR",
            "attached_by_manager": "Attached by manager",
            "attached_by_employee": "Attached by employee",
            "created_by_you": "Created by you",
            "created_by_hr": "Created by HR",
            "created_by_manager": "Created by manager",
            "created_by_employee": "Created by employee",
            "delete": "Delete",
            "delete_question": "Do you want to delete a file?",
            "cancel": "Cancel",
            "files_input_placeholder": "Click and select a file on your device or drag and drop here",
            "drop_placeholder": "Drag the file here",
            "big_file_error": "The size of one of the files more than 10 MB",
            "delete_employee_question": "Do you want to delete your account?",
            "error_individual_modal_1": "You cannot add individual activity,",
            "error_common_modal_1": "You cannot add activity,",
            "error_add_employee_1": "You cannot add employee,",
            "error_individual_modal_2": "until all required fields are filled.",
            "error_individual_modal_3": "Need to fill:",
            "create_new_event": "Create a new event"
        },
        "idp": {
            "learn_tab": "Education",
            "wish_tab": "Wishes",
            "medical_tab": "Medical/patents",
            "search_placeholder": "Find employees",
            "star_tooltip": "This employee is on the list of <br> reservists and is eligible for a <br> promotion in the near future",
            "fires_tooltip": "Fired",
            "employees": "Employees",
            "men": "men | men | men | men",
            "download_report": "Download report",
            "individual_development_plan": "Personal development plan",
            "not_formed": "Not formed",
            "on_approval": "On approval",
            "on_approval_hr": "Need to approve",
            "agreed_by_manager": "Agreed by the manager",
            "agreed_by_hr": "Agreed by HR",
            "for": "for",
            "send_to_approve_idp": "Send for approval",
            "assign_idp": "Agree IDP",
            "assign_not_assigned": "Assign uncoordinated learning",
            "add_learning_from_catalog": "Add learning from catalog",
            "mark_learning_as_complete": "Mark learning as complete",
            "load_files": "Upload files",
            "all_years": "All years",
            "yr": "г.",
            "filter_event_by_status": "Status filter",
            "competencies": "Competencies",
            "when": "When",
            "type": "Type",
            "add": "Add",
            "assign": "Assign",
            "complete": "Complete",
            "draft": "Draft",
            "assigned": "Assigned",
            "assigned_for_wish": "Assigned",
            "rejected": "Rejected",
            "canceled": "Canceled",
            "available": "Available in Academy",
            "done": "Done",
            "expired": "Expired",
            "mandatory": "Mandatory",
            "addition": "Additional",
            "additional": "Additional",
            "mandatory_security": "Mandatory for security",
            "wishes_txt": "Wishes",
            "mandatory_tooltip": "This block contains mandatory events that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "additional_tooltip": "This block contains <b><u>optional</u></b> for completing the event that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "mandatory_security_tooltip": "Events, courses and other developmental activities that are necessary to comply with occupational safety requirements.",
            "medical_tooltip": "This block contains mandatory medical examinations and patents required for admission to work.",
            "wishes_tooltip_employee": "This block contains various wishes (yours or your manager), which HR will definitely consider.",
            "wishes_tooltip_hr": "This block contains the wishes for training added by the employee, manager and you.",
            "wishes_tooltip_manager": "This block contains training wishes added by the employee, HR and you",
            "wishes_tooltip_admin": "This block contains the wishes for training added by the employee, HR and manager",
            "assignments_tooltip": "Actions are not available for learning past periods",
            "catalog": "Catalog IDP",
            "course": "Academy Courses",
            "event": "Academy events",
            "external": "External",
            "individual": "Employee IDP (individual)",
            "wishes": "Employee wish",
            "matrix": "Learning matrix",
            "others": "Others",
            "not_found_mandatory": "Learning has not been added yet. Check the filter by status",
            "not_found_mandatory_security": "Security commitments not yet added or do not match status filters",
            "not_found_addition": "Learning has not been added yet. Check the filter by status",
            "not_found_wishes": "Wishes not yet added or do not match status filters",
            "not_found_assignments": "No assignment for selected period or selected filters",
            "f_of": "Full-time",
            "f_or": "Remote",
            "f_oroli": "Remote (OLYMPOKS)",
            "f_ofr": "Full-time / Remote",
            "m_ow": "At work",
            "create_individual": "Create individual",
            "add_from_catalog": "Add from catalog",
            "cm_view": "View",
            "cm_view_edit": "View / edit",
            "cm_comment": "Leave a comment",
            "cm_reject": "Reject",
            "cm_assign": "Assign",
            "cm_delete": "Delete",
            "cm_move_to_mandatory": "In mandatory",
            "cm_move_to_additional": "In additional",
            "cm_move_to_mandatory_security": "In mandatory for security",
            "cm_attach_files": "Attach files",
            "cm_mark_as_done": "Mark as done",
            "cm_attach_new_files": "Attach new files",
            "cm_set_new_deadline": "Set a new deadline",
            "cm_cancel": "Cancel",
            "cm_assign_hr": "Assign",
            "comment": "comments | comment | comment | comments",
            "file": "files | file | file | files",
            "write_comment": "Leave a comment",
            "has_expired_activities": "Has expired activities",
            "has_inconsistent_activities": "Has inconsistent activities",
            "till": "till",
            "employee": "Employee",
            "hr": "HR",
            "manager": "Manager",
            "learning_for": "Learning for",
            "y": "y.",
            "attach_files_help": "In this window, you can upload files (for example, certificates of completion) to all employees whose training was added to the IPR in any status. <br>This option is only available for training that is added from the catalog.",
            "display_all_status_learning": "The list of employees displays only those for whom this training was added to the IPR in any status."
        },
        "catalog": {
            "add_to_idp": "Add to IDP",
            "dont_you_found": "Did not find a program or event?",
            "you_cat_create_new": "Create a wish or an individual task",
            "create_event": "Create new event",
            "assign": "Add to IDP",
            "if_not_found_create_new": "Can not find a program or event?<br>Create a wish or an individual task",
            "assign_as": "as",
            "was_assign_for": "For ",
            "was_assign_users": " employees have already been assigned",
            "assign_search_group": "Find group",
            "assign_need_activity": "You must select at least one item",
            "was_assign_show_users": "View Employees",
            "was_assign_assignments": "View Appointments",
            "assigned_activities": "Events and programs have already been scheduled",
            "code": "Code",
            "name": "Name",
            "pernumber": "Serial number",
            "phone": "Phone",
            "email": "Email",
            "format_method": "Format",
            "competencies": "Competence",
            "source": "Source",
            "competence": "Competence",
            "competences": "Competencies",
            "skills": "Competency skills",
            "all": "All",
            "format": "Format",
            "provider": "Provider",
            "format_at_workplace": "At work",
            "format_webinar": "Online course / webinar",
            "format_offline": "Training / offline program",
            "method_at_workplace": "At work",
            "method_internal_training_by_trainer": "Internal training by BU trainer (at BE)",
            "method_internal_training_by_external_trainer": "Internal training by an external trainer (on BE)",
            "method_external_group": "External group training (not on BE)",
            "method_external_individual": "External individual training (not on BE)",
            "method_probation": "Internship at other companies Nordgold",
            "method_webinar": "Online course / webinar",
            "type": "Source",
            "author": "Author",
            "category": "Category",
            "employee": "Staff",
            "when": "Deadline",
            "deadline": "Deadline",
            "set_deadline": "Set a deadline for passing",
            "mass_deadline_for_one": "Set a deadline for passing",
            "mass_deadline_for_all": "Set a deadline for everyone to pass at once",
            "mass_deadline_for_every": "Or set the deadline for passing for each employee separately",
            "set_new_deadline": "Set a new due date",
            "period": "Period",
            "comment": "Comment",
            "link": "Link",
            "link_edit": "Link (if any)",
            "description": "Description",
            "search_any_way": "Search all over",
            "edit": "Edit",
            "assign_to_employees": "Assign to employees",
            "add_as_mandatory": "Add to IDP as mandatory",
            "add_as_additional": "Add to IDP as additional",
            "add_as_security_commitment": "Add to IDP as mandatory security",
            "view": "View",
            "view_assignment": "See assignments",
            "not_fully_valid": "All required fields are <br> not filled in the card",
            "assignment_title": "In the IDP for employees:",
            "name_placeholder": "Enter the name",
            "add_competence": "Add competency",
            "add_another_competence": "Add another competency",
            "what_to_do": "What should be done",
            "how_to_develop": "How do I develop it",
            "priority": "Priority",
            "additional_info": "Additional info",
            "additional_info_helper": "Specify the provider, the link to the event or other important information",
            "clear_competence": "Delete",
            "add_skill": "Add skill",
            "add_another_skill": "Add another skill",
            "choose_competence": "Choose a competency",
            "choose_format_method": "Choose a format",
            "choose_skill": "Choose a skill",
            "course": "Course in NG Academy",
            "event": "Events in NG Academy",
            "external": "External",
            "start_typing_for_search": "Start typing to search",
            "no_result_name": "No results for",
            "template": "Template",
            "create_template": "Create template",
            "edit_template": "Edit template",
            "template_name": "Template name",
            "add_event": "Add event",
            "event_placeholder": "Choose a program or event",
            "selected_event": "Selected events",
            "learning": "Event \"",
            "learning_already_exists": "\" has already been added to the employee's IDP",
            "learning_already_exists_in_employee": "\" has already been added to the employee's IDP",
            "go_to_my_idp": "Go to my IDP",
            "mass_assign_alert_1": "Event",
            "mass_assign_alert_2": "has already been assigned to the employees you selected:"
        },
        "voc": {
            "download_form": "Form",
            "recruitment_date": "Start date",
            "transferred_to_another_position": "Transferred to another position",
            "end_of_probation": "End of probation period",
            "working": "Works",
            "not_working_yet": "Before work",
            "managers": "Managers",
            "managers_empty": "No information about the managers",
            "manager": "Manager",
            "functional_managers": "Functional managers",
            "functional_managers_empty": "No information about the functional managers",
            "functional_manager": "Functional manager",
            "mentor": "Mentor",
            "choose_you_destiny": "Choose an employee from the list",
            "not_selected": "Not chosen",
            "mentor_not_required": "Mentor is optional",
            "newbie_coming_in_3_days": "New employee start date",
            "table_pernumber": "P/n",
            "table_id": "ID",
            "table_fullname": "Full Name",
            "table_position": "Position",
            "table_subdivision": "Subdivision",
            "table_status_idp": "Status IDP",
            "table_status_activity": "Status activity",
            "table_date_come": "Start date",
            "table_status": "Status",
            "table_format": "Development format",
            "table_deadline": "Deadline",
            "table_date": "Date",
            "table_close_sidebar": "Hide list of employees",
            "table_open_sidebar": "Show list of employees",
            "table_author": "Author",
            "table_series": "Series and number",
            "table_type": "Type",
            "newbie_no_tasks_after_8_days": "Probation period task setting",
            "newbie_no_verified_tasks_before_7_days": "Decision on probation period ",
            "probation_period_is": "Consider probation period to be",
            "waiting_probation_period_decision": "Decision is pending",
            "succeed_probation_period_decision": "Successful",
            "no_assigned_managers": "No managers",
            "end_of_shift": "End of the 1st rotation",
            "yes": "Yes",
            "no": "No",
            "all": "All",
            "add_mentor_modal_title": "Employee's mentor",
            "mentor_field": "Mentor",
            "mentor_field_default": "Choose mentor from the list",
            "mentor_add_button": "Appoint",
            "mentor_reset_button": "Delete",
            "delete_mentor_error": "Error in deleting mentor. Contact the support service.",
            "mentor_field_can_edit": "Can manage tasks",
            "mentor_not_from_same_department": "Mentor must be from the same department",
            "mentor_not_from_same_company": "Mentor must be from the same company",
            "mentor_and_newbie_same_user": "Mentor and employee cannot be same person",
            "add_mentor_error": "Error in adding mentor",
            "error": "Error",
            "welcome_home_link": "Main",
            "relations": "Connections",
            "mentor_assigned": "Appointment as a mentor",
            "no_shift_end": "Not defined",
            "no_feature_for_role": "Sorry, but there is no functionality for your role",
            "no_copy_tasks": "There are no previously created tasks for this position.",
            "newbie_no_certificate": "Certificate loading function is not available.",
            "probation_period_success": "Probation is successful!",
            "congrats": "Congratulations and we wish you productive work at Nordgold",
            "download_certificate": "Download certificate",
            "shift_at": "End of the 1st rotation",
            "your_probe_period_is_end": "Your probation period has been successfully completed.",
            "you_have_not_newbies": "You have no employees on probation period.",
            "control_probation_period_report": "Probation period from %s to %s",
            "group_subdivision": "Employee division",
            "company": "Company",
            "employee_probation_period_status": "Status",
            "employee_probation_period_status_process": "in process",
            "employee_probation_period_status_passed": "passed",
            "employee_probation_period_status_not_passed": "failed",
            "employees": "Employees",
            "catalog": "Catalog",
            "idp": "IDP",
            "my_idp": "My IDP",
            "academy_eriell": "Academy Eriell",
            "date_create_task": "Tasks setting date",
            "date_evaluate_task": "Tasks evaluation date",
            "date_dismissal": " Termination date",
            "choose_all_companies": "All BU",
            "choose_all_departments": "All departments",
            "mentor_field_filter": "Filter",
            "mentor_field_filter_button": "Search",
            "mentor_field_filter_placeholder": "Employee ID, Surname, Name, Position",
            "short_tab_number": "Emp ID",
            "choose_mentor_from_dropdown_list": "Select mentor from dropdown list",
            "russian": "Russian",
            "english": "English",
            "french": "French",
            "save": "Save",
            "skip": "Skip",
            "from": "from",
            "to": "to",
            "at": "at",
            "today": "today",
            "yesterday": "yesterday",
            "view_individual_education": "View individual learning",
            "view_common_education": "View learning",
            "view_desire": "View wish",
            "view_event": "View learning",
            "edit_individual_education": "Edit individual learning",
            "edit_common_education": "Edit learning",
            "edit_desire": "Edit wish",
            "edit_event": "Edit learning",
            "create_individual_education": "Create individual learning",
            "create_desire": "Create wish",
            "create_deadline": "Create deadline",
            "create_new_deadline": "Create new deadline",
            "is_hidden": "Hidden",
            "delete": "Delete",
            "actions": "Actions",
            "warning_actions_employee": "To see the available actions, select employees from the list",
            "warning_actions_activity": "To see the available actions, select a learning from the list",
            "common_employee": "Worker",
            "specialist_manager": "Supervisor",
            "engineering_staff": "Engineering stuff",
            "loading": "Loading...",
            "table_event_name": "Name of activity",
            "table_direction": "Direction",
            "table_company": "Company",
            "table_periodicity": "Periodicity"
        }
    },
    "ru": {
        "admin": {
            "new_emp": "Новый сотрудник",
            "new_hr": "Новый HR",
            "new_mentor": "Новый наставник",
            "new_manager": "Новый руководитель",
            "new_functional_manager": "Новый функц. руководитель",
            "import": "Импорт",
            "manual": "Вручную",
            "Batch": "Пакетная",
            "export": "Экспорт",
            "log_history": "История логов",
            "tab_number": "Табельный номер",
            "employee": "Сотрудник",
            "employees": "Сотрудники",
            "company": "Компания",
            "business_item": "Бизнес-единица (БЕ)",
            "companies": "Компании",
            "no_companies_users": "Пользователи не найдены",
            "department": "Раздел сотрудника",
            "position": "Должность",
            "fired_at": "Дата увольнения",
            "phone": "Телефон",
            "in_system": "На исп. сроке",
            "in_white_list": "В белом списке",
            "source": "Источник",
            "employee_data": "Данные сотрудника",
            "pernumber": "Таб. номер",
            "novice": "Да",
            "not_novice": "Нет",
            "roles": "Роли",
            "email": "Email",
            "subdivision": "Подразделение 1 уровня",
            "subdivision2": "Подразделение 2 уровня",
            "subdivision3": "Подразделение 3 уровня",
            "subdivision4": "Подразделение 4 уровня",
            "subdivision5": "Подразделение 5 уровня",
            "no_division": "Не указано",
            "mentor_can_edit": "Расширенные права наставника",
            "without_probation": "Не предусмотрен испытательный срок",
            "user_not_found": "Сотрудник не найден.",
            "employee_imported": "Сотрудники успешно импортированы.",
            "notify_button": "Оповещения",
            "config_notification_title": "Выбрать сотрудников",
            "save_settings": "Сохранить",
            "notification_settings_updated": "Настройки оповещения БЕ обновлены.",
            "notification_settings_failed_updated": "Настройки оповещения БЕ не обновлены.",
            "add_subgroup": "Добавить подгруппу",
            "new_group": "Новая группа",
            "add_competence": "Добавить компетенцию",
            "add_skill": "Добавить навык",
            "add_provider": "Добавить поставщика",
            "rename_provider": "Переименовать поставщика",
            "delete_provider_question": "Вы хотите удалить поставщика",
            "provider": "Провайдер",
            "russian": "Русский",
            "english": "Английский",
            "french": "Французский",
            "providers": "Провайдеры",
            "provider_add_error": "При добавлении поставщика возникла ошибка",
            "provider_edit_error": "При редактировании поставщика возникла ошибка",
            "provider_add_success": "Поставщик успешно добавлен",
            "provider_edit_success": "Поставщик успешно изменен",
            "provider_delete_success": "Поставщик успешно удален",
            "can_edit_catalog": "Может работать с каталогом",
            "report_button": "Отчет",
            "competences": "Компетенции",
            "rename": "Переименовать",
            "delete": "Удалить",
            "hide": "Сделать неактивной",
            "show": "Сделать активной",
            "matrix": "Матрица",
            "report_idp": "Отчет по ИПР",
            "report_mandatory_learning": "Отчет по обязательному обучению",
            "id": "ID",
            "be": "БЕ",
            "not_delete": "Вы можете удалить только ту учетную запись, которая входит в белый список",
            "not_delete_manager": "Вы можете удалить только ту связь, которую создали вручную",
            "create_employee": "Новый сотрудник",
            "connections": "Связи",
            "office": "Офис / филиал",
            "fio": "ФИО",
            "fio_hr": "ФИО нового HR",
            "delete_manager_link_question": "Вы хотите удалить привязку руководителя?",
            "delete_fmanager_link_question": "Вы хотите удалить привязку функц. руководителя?",
            "fmanager": "Функц. руководитель",
            "employee_type": "Тип сотрудника",
            "hide_inactive": "Скрыть неактивные",
            "add_matrix_activity": "Добавить обучение в матрицу",
            "import_matrix": "Импорт матрицы",
            "make_active": "Сделать активным",
            "make_not_active": "Сделать неактивным",
            "main_qualification": "Квалификация (основная)",
            "optional_qualification": "Квалификация (дополнительная)",
            "pbiot": "ПБиОТ",
            "first_aid": "Первая помощь",
            "ecology": "Экология",
            "gnvp": "ГНВП",
            "professional": "Профессиональное",
            "one_time": "1 раз",
            "one_time_in_year": "1 раз в год",
            "one_time_in_two_years": "1 раз в 2 года",
            "one_time_in_three_years": "1 раз в 3 года",
            "one_time_in_five_years": "1 раз в 5 лет",
            "one_time_in_ten_years": "1 раз в 10 лет",
            "active": "Активно",
            "not_active": "Неактивно",
            "mandatory": "Обязательное",
            "additional": "Дополнительное",
            "certificate": "Сертификат",
            "qualification_certificate": "Квалификационное удостоверение",
            "protocol": "Протокол",
            "protocol_identity": "Протокол / удостоверение",
            "create_matrix": "Добавить обязательное обучение",
            "edit_matrix": "Редактирование обязательного обучения",
            "direction": "Направление",
            "priority": "Приоритет",
            "documents": "Документы",
            "periodicity": "Периодичность",
            "activity_link": "Ссылка на обучение в «Каталоге»",
            "matrix_import_error": "Импорт матрицы обучения невозможен, \nтак как одно  или несколько полей не соответствует \nустановленному формату. \nПроверьте файл и загрузите корректную версию еще раз."
        },
        "auth": {
            "login-header": "Авторизуйтесь в модуле ИПР",
            "remember-me": "Запомнить меня",
            "login": "Войти",
            "logout": "Выйти",
            "pernumber": "Табeльный номер",
            "password": "Пароль",
            "register": "Зарегистрироваться",
            "failed": "Неверный табельный номер или пароль. Проверьте еще раз",
            "throttle": "Много попыток авторизации. Попробуйте снова через {seconds} с.",
            "token_not_found": "Токен пользователя не найден."
        },
        "role": {
            "admin": "Администратор",
            "manager": "Руководитель",
            "managers": "Руководители",
            "fmanager": "Функциональный руководитель",
            "fmanagers": "Функциональные руководители",
            "employee": "Сотрудник",
            "employees": "Сотрудники",
            "mentor": "Наставник",
            "hr": "HR",
            "newbie": "Новый сотрудник"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "Поле обязательно для заполнения.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "{attribute} уже занят.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "plan_greater_probation": "Планируемая дата позднее даты окончания испытательного срока.",
            "you_have_no_assigned_tasks": "У вас есть не назначенные задачи.",
            "path_to_file_corrupt": "Путь до файла пуст или повреждён.",
            "task_without_plan_date": "Есть задачи без планируемого срока выполнения.",
            "you_have_no_tasks": "Нет назначенных заданий.",
            "report_settings_required": "Заполните все поля.",
            "report_company_not_exist": "Такой компании не существует.",
            "report_bad_date_format": "Неверный формат дат периода отчета.",
            "can_not_be_competence": "Не может быть компетенцией.",
            "can_not_be_not_competence": "Не может быть группой/подгруппой.",
            "can_not_hide_not_competence": "Нельзя скрыть группу/подгруппу.",
            "can_not_remove_not_empty_group": "Нельзя удалить не пуступ группу/подгруппу.",
            "can_not_remove_assigned_competence": "Нельзя удалить компетенцию, которая прикреплена к мероприятию/курсу.",
            "can_not_add_skill_to_competence": "Нельзя добавить навык к не компетенции.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "ФИО",
                "pernumber": "Табельный номер"
            },
            "import": {
                "pernumber_empty": "Не указан табельный номер",
                "pernumber_only_digits": "Табельный номер может содержать только числа",
                "pernumber_not_unique": "Неуникальный табельный номер",
                "surname_not_exists": "Не заполнена фамилия сотрудника",
                "firstname_not_exists": "Не заполнено имя сотрудника",
                "invalid_phone": "Неверный формат номера телефона. Допускается от 11 до 16 числовых символов",
                "not_unique_phone": "Неуникальный номер телефона",
                "invalid_email": "Неверный формат для электронной почты",
                "not_unique_email": "Неуникальная электронная почта",
                "empty_company": "Не заполнена компания сотрудника",
                "not_exist_company": "В системе нет такой компании",
                "empty_department": "Не заполнен раздел сотрудника",
                "not_exist_department": "В системе нет такого раздела сотрудника",
                "empty_position": "Не заполнена должность сотрудника",
                "not_exist_position": "В системе нет такой должности",
                "hired_empty": "Не заполнена дата принятия на работу",
                "invalid_date_format_hired": "Неверный формат даты принятия на работу. Допускается формат 01/01/2020",
                "invalid_date_format_shift": "Неверный формат даты даты окончания вахты. Допускается формат 01/01/2020",
                "invalid_date_format_period": "Неверный формат даты конца испытательного срока. Допускается формат 01/01/2020",
                "save_user_error": "Ошибка при сохранении пользователя",
                "not_exist_subdivision": "В системе нет такого подразделения"
            }
        },
        "modal": {
            "when_placeholder": "Выберите даты проведения",
            "provider_placeholder": "Выберите провайдера",
            "place_placeholder": "Укажите место проведения",
            "duration_placeholder": "Впишите длительность в часах",
            "link_placeholder": "Вставьте ссылку",
            "comment_placeholder": "Впишите комментарий",
            "description_placeholder": "Впишите описание",
            "attached_by_you": "Прикреплено вами",
            "attached_by_hr": "Прикреплено HR",
            "attached_by_manager": "Прикреплено руководителем",
            "attached_by_employee": "Прикреплено сотрудником",
            "created_by_you": "Создано вами",
            "created_by_hr": "Создано HR",
            "created_by_manager": "Создано руководителем",
            "created_by_employee": "Создано сотрудником",
            "delete": "Удалить",
            "delete_question": "Вы хотите удалить файл?",
            "cancel": "Отмена",
            "files_input_placeholder": "Кликните и выберите файл на устройстве или перетащите сюда",
            "drop_placeholder": "Перетащите файл сюда",
            "big_file_error": "Размер одного из файлов превышает 10 мб",
            "delete_employee_question": "Вы хотите удалить учетную запись?",
            "error_individual_modal_1": "Вы не можете добавить индивидуальное обучение,",
            "error_common_modal_1": "Вы не можете добавить обучение,",
            "error_add_employee_1": "Вы не можете добавить сотрудника,",
            "error_individual_modal_2": "пока не заполнены все обязательные поля.",
            "error_individual_modal_3": "Нужно заполнить:",
            "create_new_event": "Создание нового обучения"
        },
        "catalog": {
            "add_to_idp": "Добавить в ИПР",
            "dont_you_found": "Не нашли программу или мероприятие?",
            "you_cat_create_new": "Создайте пожелание или индивидуальную задачу",
            "create_event": "Создать новое обучение",
            "assign": "Добавить в ИПР",
            "if_not_found_create_new": "Не нашли программу или мероприятие?<br>Создайте пожелание или индивидуальную задачу",
            "assign_as": "как",
            "was_assign_for": "Для ",
            "was_assign_users": " уже были назначены сотрудники",
            "assign_search_group": "Найти группу",
            "assign_need_activity": "Необходимо выбрать хотя бы одну позицию",
            "was_assign_show_users": "Просмотреть сотрудников",
            "was_assign_assignments": "Просмотр назначений",
            "assigned_activities": "Мероприятия и программы уже были назначены",
            "code": "Код",
            "name": "Название",
            "pernumber": "Порядковый номер",
            "phone": "Телефон",
            "email": "Email",
            "format_method": "Формат",
            "competencies": "Компетенция",
            "source": "Источник",
            "competence": "Компетенция",
            "competences": "Компетенции",
            "skills": "Навыки компетенций",
            "all": "Все",
            "format": "Формат",
            "provider": "Провайдер",
            "format_at_workplace": "На рабочем месте",
            "format_webinar": "Онлайн-курс / вебинар",
            "format_offline": "Тренинг / офлайн программа",
            "method_at_workplace": "На рабочем месте",
            "method_internal_training_by_trainer": "Внутренний тренинг тренером БЕ (на БЕ)",
            "method_internal_training_by_external_trainer": "Внутреннее обучение внешним тренером (на БЕ)",
            "method_external_group": "Внешнее групповое обучение (не на БЕ)",
            "method_external_individual": "Внешнее индивидуальное обучение (не на БЕ)",
            "method_probation": "Стажировка на других предприятиях Nordgold",
            "method_webinar": "Онлайн курс / вебинар",
            "type": "Источник",
            "author": "Автор",
            "category": "Категория",
            "employee": "Персонал",
            "when": "Дедлайн",
            "deadline": "Дедлайн",
            "set_deadline": "Установите крайний срок прохождения",
            "mass_deadline_for_one": "Установите крайний срок прохождения",
            "mass_deadline_for_all": "Установите крайний срок прохождения для всех сразу",
            "mass_deadline_for_every": "Или установите крайний срок прохождения для каждого сотрудника по-отдельности",
            "set_new_deadline": "Установите новый срок прохождения",
            "period": "Период",
            "comment": "Комментарий",
            "link": "Ссылка",
            "link_edit": "Ссылка (если есть)",
            "description": "Описание",
            "search_any_way": "Поиск по всему",
            "edit": "Редактировать",
            "assign_to_employees": "Назначить сотрудникам",
            "add_as_mandatory": "Добавить в ИПР как обязательное",
            "add_as_additional": "Добавить в ИПР как дополнительное",
            "add_as_security_commitment": "Добавить в ИПР как обязательство по безопасности",
            "view": "Смотреть",
            "view_assignment": "Смотреть назначения",
            "not_fully_valid": "В карточке не заполнены <br> все необходимые поля",
            "assignment_title": "В ИПР у сотрудников:",
            "name_placeholder": "Впишите название",
            "add_competence": "Добавить компетенцию",
            "add_another_competence": "Добавить еще компетенцию",
            "what_to_do": "Что нужно сделать",
            "how_to_develop": "Как я хочу это развить",
            "priority": "Приоритет",
            "additional_info": "Дополнительная информация",
            "additional_info_helper": "Укажите провайдера, ссылку на мероприятие или прочую важную информацию",
            "clear_competence": "Удалить",
            "add_skill": "Добавить навык",
            "add_another_skill": "Добавить еще навык",
            "choose_competence": "Выберите компетенцию",
            "choose_format_method": "Выберите формат",
            "choose_skill": "Выберите навык",
            "course": "Курс в NG Academy",
            "event": "Мероприятие в NG Academy",
            "external": "Вне платформы",
            "start_typing_for_search": "Начните печатать для поиска",
            "no_result_name": "Нет результатов для",
            "template": "Шаблон",
            "create_template": "Создать шаблон",
            "edit_template": "Редактировать шаблон",
            "template_name": "Название шаблона",
            "add_event": "Добавить мероприятие",
            "event_placeholder": "Выберите программу или мероприятие",
            "selected_event": "Выбранные мероприятия",
            "learning": "Обучение \"",
            "learning_already_exists": "\" уже было добавлено в ИПР сотрудника",
            "learning_already_exists_in_employee": "\" уже было добавлено в ИПР сотрудника",
            "go_to_my_idp": "Перейти в мой ИПР",
            "mass_assign_alert_1": "Обучение",
            "mass_assign_alert_2": "уже было назначено выбранным вами сотрудникам:"
        },
        "idp": {
            "learn_tab": "Обучение",
            "wish_tab": "Пожелания",
            "medical_tab": "Медосмотры/патенты",
            "search_placeholder": "Найти сотрудников",
            "employee_list": "Список сотрудников",
            "star_tooltip": "Этот сотрудник входит в список <br> резервистов и претендует на <br> повышение в ближайшем будущем",
            "fires_tooltip": "Уволен",
            "employees": "Сотрудники",
            "men": "человек | человек | человека | человек",
            "download_report": "Скачать отчёт",
            "individual_development_plan": "Индивидуальный план развития",
            "not_formed": "Не сформирован",
            "on_approval": "На согласовании",
            "on_approval_hr": "Нужно согласовать",
            "agreed_by_manager": "Согласован руководителем",
            "agreed_by_hr": "Согласован",
            "for": "на",
            "send_to_approve_idp": "Отправить на согласование",
            "assign_idp": "Согласовать ИПР",
            "assign_not_assigned": "Согласовать несогласованное обучение",
            "add_learning_from_catalog": "Добавить обучение из каталога",
            "mark_learning_as_complete": "Пометить обучение как пройденное",
            "change_learning_status": "Сменить статус обучения",
            "change_learning_statuses": "Сменить статусы обучения",
            "load_files": "Подгрузить файлы",
            "all_years": "Все года",
            "yr": "г.",
            "filter_event_by_status": "Фильтр по статусам",
            "competencies": "Компетенции",
            "when": "Когда",
            "type": "Тип",
            "add": "Добавить",
            "assign": "Назначить",
            "complete": "Выполнено",
            "draft": "Черновик",
            "assigned": "Назначено",
            "assigned_for_wish": "Согласовано",
            "rejected": "Отклонено",
            "canceled": "Отменено",
            "available": "Доступно в Академии",
            "done": "Выполнено",
            "expired": "Просрочено",
            "mandatory": "Обязательные",
            "addition": "Дополнительные",
            "additional": "Дополнительные",
            "mandatory_security": "Обязательства по безопасности",
            "wishes_txt": "Пожелания",
            "mandatory_tooltip": "В этом блоке размещаются обязательные для прохождения мероприятия, которые добавляет HR. Вы также можете добавить мероприятия из каталога или создать сами по согласованию с HR или руководителем.",
            "additional_tooltip": "В этом блоке размещаются <b><u>необязательные</u></b> для прохождения мероприятия, которые добавляет HR. Вы также можете добавить мероприятия из каталога или создать сами по согласованию с HR или руководителем.",
            "mandatory_security_tooltip": "Мероприятия, курсы и другие развивающие действия, которые необходимы для соответствия требованиям по безопасности труда.",
            "medical_tooltip": "В этом блоке размещаются обязательные к прохождению медосмотры и патенты, необходимые для допуска на работу.",
            "wishes_tooltip_employee": "В этом блоке размещаются различные пожелания (ваши или вашего руководителя), которые обязательно рассмотрит HR.",
            "wishes_tooltip_hr": "В этом блоке размещаются пожелания к обучению, добавленные сотрудником, руководителем и вами.",
            "wishes_tooltip_manager": "В этом блоке размещаются пожелания к обучению, добавленные сотрудником, HR-ом и вами",
            "wishes_tooltip_admin": "В этом блоке размещаются пожелания к обучению, добавленные сотрудником, HR-ом и руководителем",
            "assign_not_assigned_help": "Выбранный вами статус дет автоматически установлен для всего <br> несогласованного обучения в статусе \"Черновик\".",
            "change_learning_status_help": "Сменить статусы обучения можно только в согласованных ИПР для того обучения, которое не проходится на внешних платформах (Академия Eriell). Обучение должно находиться в статусе \"Назначено\". <br> <br> <br> Обратите внимание, что индивидуальное обучение нужно согласовывать индивидуально для каждого сотрудника!",
            "select_learning_activity": "Выберите обучение из списка ниже",
            "display_only_with_assigned_learning": "В списке сотрудников отображаются только те, кому данное обучение было назначено.",
            "assignments_tooltip": "Действия недоступны для обучения прошедших периодов",
            "catalog": "Каталог ИПР",
            "course": "Курсы Академии",
            "event": "Мероприятия Академии",
            "external": "Вне платформы",
            "individual": "ИПР сотрудника (индивидуальное)",
            "wishes": "Пожелание сотрудника",
            "matrix": "Матрица обучения",
            "others": "Прочие",
            "not_found_mandatory": "Обучение еще не добавлено. Проверьте фильтр по статусам",
            "not_found_mandatory_security": "Обязательства по безопасности еще не добавлены или не соответствуют фильтрам по статусу",
            "not_found_addition": "Обучение еще не добавлено. Проверьте фильтр по статусам",
            "not_found_wishes": "Пожелания еще не добавлены или не соответствуют фильтрам по статусу",
            "not_found_assignments": "Нет назначения для выбранного периода или выбранных фильтров",
            "f_of": "Очный",
            "f_or": "Дистанционный",
            "f_oroli": "Дистанционный (ОЛИМПОКС)",
            "f_ofr": "Очный / дистанционный",
            "m_ow": "На рабочем месте",
            "create_individual": "Создать индивидуальное",
            "add_from_catalog": "Добавить из каталога",
            "cm_view": "Посмотреть",
            "cm_view_edit": "Посмотреть / отредактировать",
            "cm_comment": "Оставить комментарий",
            "cm_reject": "Отклонить",
            "cm_assign": "Согласовать",
            "cm_delete": "Удалить",
            "cm_move_to_mandatory": "В обязательные",
            "cm_move_to_additional": "В дополнительные",
            "cm_move_to_mandatory_security": "В обязательные по безопасности",
            "cm_attach_files": "Прикрепить файлы",
            "cm_mark_as_done": "Пометить как выполненное",
            "cm_attach_new_files": "Приложить новые файлы",
            "cm_set_new_deadline": "Установить новый дедлайн",
            "cm_cancel": "Отменить",
            "cm_assign_hr": "Назначить",
            "comment": "комментариев | комментарий | комментария | комментариев",
            "file": "файлов | файл | файла | файлов",
            "write_comment": "Оставить комментарий",
            "has_expired_activities": "Есть просроченное обучение",
            "has_inconsistent_activities": "Есть несогласованное обучение",
            "till": "до",
            "employee": "Сотрудник",
            "hr": "HR",
            "manager": "Руководитель",
            "learning_for": "Обучение за",
            "y": "г.",
            "attach_files_help": "В этом окне вы можете подгрузить файлы (например, сертификаты о прохождении) всем сотрудникам, у которых обучение было добавлено в ИПР в любом статусе. <br>Данная опция доступна только для обучения, которое добавляется из каталога.",
            "display_all_status_learning": "В списке сотрудников отображаются только те, кому данное обучение было добавлено в ИПР в любом статусе."
        },
        "voc": {
            "download_form": "Форма",
            "recruitment_date": "Дата приёма",
            "transferred_to_another_position": "Переведён на другую должность",
            "end_of_probation": "Окончание испыт. срока",
            "working": "Работает",
            "not_working_yet": "До начала работы",
            "managers": "Руководители",
            "managers_empty": "Нет информации о руководителях",
            "manager": "Руководитель",
            "functional_managers": "Функциональные руководители",
            "functional_managers_empty": "Нет информации о функциональных руководителях",
            "functional_manager": "Функциональный руководитель",
            "mentor": "Наставник",
            "choose_you_destiny": "Выберите сотрудника из списка",
            "not_selected": "Не выбран",
            "mentor_not_required": "Наставник необязателен",
            "newbie_coming_in_3_days": "Выход нового сотрудника",
            "table_pernumber": "T/н",
            "table_id": "ID",
            "table_fullname": "ФИО",
            "table_position": "Должность",
            "table_subdivision": "Подразделение",
            "table_status_idp": "Статус ИПР",
            "table_status_activity": "Статус обучения",
            "table_date_come": "Дата выхода",
            "table_status": "Статус",
            "table_format": "Формат развития",
            "table_deadline": "Дедлайн",
            "table_date": "Срок",
            "table_close_sidebar": "Скрыть список сотрудников",
            "table_open_sidebar": "Показать список сотрудников",
            "table_author": "Автор",
            "table_series": "Серия и номер",
            "table_type": "Тип",
            "newbie_no_tasks_after_8_days": "Постановка задач на испытательный срок",
            "newbie_no_verified_tasks_before_7_days": "Решение по результатам испытательного срока",
            "probation_period_is": "Испытательный срок считать",
            "waiting_probation_period_decision": "Ожидание решения",
            "succeed_probation_period_decision": "Успешно завершенным",
            "no_assigned_managers": "Не назначено",
            "end_of_shift": "Окончание 1 вахты",
            "yes": "Да",
            "no": "Нет",
            "all": "Все",
            "add_mentor_modal_title": "Наставник сотрудника",
            "mentor_field": "Наставник",
            "mentor_field_default": "Выберите наставника из списка",
            "mentor_add_button": "Назначить",
            "mentor_reset_button": "Удалить",
            "delete_mentor_error": "Ошибка при удалении наставника. Обратитесь в службу поддержки.",
            "mentor_field_can_edit": "Может управлять заданиями",
            "mentor_not_from_same_department": "Наставник должен быть из того же подразделения",
            "mentor_not_from_same_company": "Наставник должен быть из той же компании",
            "mentor_and_newbie_same_user": "Наставник и сотрудник не могут быть одинаковым",
            "add_mentor_error": "Ошибка при добавлении наставника",
            "error": "Error",
            "welcome_home_link": "Главная",
            "relations": "Связи",
            "mentor_assigned": "Назначение наставником",
            "no_shift_end": "Не установлено",
            "no_feature_for_role": "Извините, но для вашей роли не предусмотрено функционала",
            "no_copy_tasks": "Для этой должности нет ранее созданных задач.",
            "probation_period_success": "Испытательный срок пройден успешно!",
            "congrats": "Поздравляем и желаем продуктивной работы в Nordgold",
            "download_certificate": "Скачать сертификат",
            "newbie_no_certificate": "Функция загрузки сертификата не доступна.",
            "shift_at": "Окончание 1 вахты",
            "your_probe_period_is_end": "Ваш испытательный срок успешно завершен.",
            "you_have_not_newbies": "У вас нет сотрудников на испытательном сроке.",
            "control_probation_period_report": "Контроль прохождения испытательного срока с %s по %s",
            "group_subdivision": "Раздел сотрудника",
            "company": "Компания",
            "employee_probation_period_status": "Статус",
            "employee_probation_period_status_process": "в процессе",
            "employee_probation_period_status_passed": "прошел",
            "employee_probation_period_status_not_passed": "не прошел",
            "employees": "Сотрудники",
            "catalog": "Каталог",
            "idp": "ИПР",
            "my_idp": "Мой ИПР",
            "academy_eriell": "Академия Eriell",
            "date_create_task": "Дата постановки задачи",
            "date_evaluate_task": "Дата оценки задачи",
            "date_dismissal": "Дата увольнения",
            "choose_all_companies": "Все компании",
            "choose_all_departments": "Все подразделения",
            "mentor_field_filter": "Фильтр",
            "mentor_field_filter_button": "Поиск",
            "mentor_field_filter_placeholder": "ФИО, должность, табельный номер",
            "short_tab_number": "Таб.номер",
            "choose_mentor_from_dropdown_list": "Выберите наставника из списка",
            "russian": "Русский",
            "english": "Английский",
            "french": "Французский",
            "save": "Сохранить",
            "skip": "Пропустить",
            "from": "с",
            "to": "по",
            "at": "в",
            "today": "сегодня",
            "yesterday": "вчера",
            "view_individual_education": "Просмотр индивидуального обучения",
            "view_common_education": "Просмотр обучения",
            "view_desire": "Просмотр пожелания",
            "view_event": "Просмотр обучения",
            "edit_individual_education": "Редактирование индивидуального обучения",
            "edit_common_education": "Редактирование обучения",
            "edit_desire": "Редактирование пожелания",
            "edit_event": "Редактирование обучения",
            "create_individual_education": "Создание индивидуального обучения",
            "create_desire": "Создание пожелания",
            "create_deadline": "Установить дедлайн",
            "create_new_deadline": "Установить новый дедлайн",
            "is_hidden": "Скрыт",
            "delete": "Удалить",
            "actions": "Действия",
            "warning_actions_employee": "Чтобы посмотреть доступные действия, выберите сотрудников из списка",
            "warning_actions_activity": "Чтобы посмотреть доступные действия, выберите обучение из списка",
            "common_employee": "Рабочий",
            "specialist_manager": "Руководитель",
            "engineering_staff": "Инженерно-технический персонал",
            "loading": "Загрузка...",
            "table_event_name": "Название обучения",
            "table_direction": "Направление",
            "table_company": "Компания",
            "table_periodicity": "Периодичность"
        }
    }
}
